module.exports = "../images/facebook.svg?v=e02ee06";